import { render, staticRenderFns } from "./LabelTable.vue?vue&type=template&id=1bd3689b&scoped=true&"
import script from "./LabelTable.vue?vue&type=script&lang=js&"
export * from "./LabelTable.vue?vue&type=script&lang=js&"
import style0 from "./LabelTable.vue?vue&type=style&index=0&id=1bd3689b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3689b",
  null
  
)

export default component.exports